import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, NewsDetailReducer, NewsDetailState } from './news-detail-reducer';

const NewsDetailContext = createContext<NewsDetailState | undefined>(undefined);
const NewsDetailContextDispatchContext = createContext({} as any);

const NewsDetailProvider = ({ children }: { children: React.ReactNode }) => {
    const initialState: NewsDetailState = {
        detail: null,
        loading: false,
        error: null,
    };

    const [state, dispatch] = useReducer(NewsDetailReducer, initialState);

    return (
        <NewsDetailContext.Provider value={state}>
            <NewsDetailContextDispatchContext.Provider value={dispatch}>
                {children}
            </NewsDetailContextDispatchContext.Provider>
        </NewsDetailContext.Provider>
    );
}

const useNewsDetailState = () => {
    const context = useContext(NewsDetailContext);
    if (context === undefined) {
        throw new Error('useNewsDetailState must be used within a NewsDetailProvider');
    }
    return context;
}

const useNewsDetailDispatch = () => {
    const context = useContext(NewsDetailContextDispatchContext);
    if (context === undefined) {
        throw new Error('useNewsDetailDispatch must be used within a NewsDetailProvider');
    }
    return context;
}

export { NewsDetailProvider, useNewsDetailState, useNewsDetailDispatch, ACTION_TYPES };
